import { render } from "./Submittal.vue?vue&type=template&id=55e1af74&scoped=true"
import script from "./Submittal.vue?vue&type=script&lang=js"
export * from "./Submittal.vue?vue&type=script&lang=js"

import "./Submittal.vue?vue&type=style&index=0&id=55e1af74&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e1af74"]])

export default __exports__